import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

const LocationFilters = ({ setCardsFilters, cardsFilters, onResetFilters }) => {
  const handleExpirationChange = event => {
    setCardsFilters(filters => ({
      ...filters,
      expiration: event.target.value,
    }));
  };

  const handleTrailerChange = event => {
    setCardsFilters(filters => ({
      ...filters,
      trailer: event.target.value,
    }));
  };

  const handleStatusChange = event => {
    setCardsFilters(filters => ({
      ...filters,
      status: event.target.value,
    }));
  };

  return (
    <>
      <TextField
        fullWidth
        label="Trailer"
        name="trailer"
        onChange={handleTrailerChange}
        value={cardsFilters.trailer}
      />

      <FormControl fullWidth sx={{ mt: 3 }}>
        <InputLabel id="exp-filter-label">Expiration</InputLabel>
        <Select
          label="Expiration"
          labelId="exp-filter-label"
          onChange={handleExpirationChange}
          value={cardsFilters.expiration}
        >
          <MenuItem value="Any">Any</MenuItem>
          <MenuItem value="Valid">Valid</MenuItem>
          <MenuItem value="Expired">Expired</MenuItem>
          <MenuItem value="30 Days">Expires within 30 days</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <InputLabel id="status-filter-label">Status</InputLabel>
        <Select
          label="Status"
          labelId="status-filter-label"
          onChange={handleStatusChange}
          value={cardsFilters.status}
        >
          <MenuItem value="Any">Any</MenuItem>
          <MenuItem value="PENDING">Pending</MenuItem>
          <MenuItem value="ACTIVE">Active</MenuItem>
          <MenuItem value="INACTIVE">Inactive</MenuItem>
          <MenuItem value="GRACE">Grace Period</MenuItem>
          <MenuItem value="DEACTIVATED">Deactivated</MenuItem>
          <MenuItem value="WARNING">Warning</MenuItem>
        </Select>
      </FormControl>

      <Button fullWidth onClick={onResetFilters} sx={{ mt: 2 }} variant="text">
        Clear
      </Button>
    </>
  );
};

LocationFilters.propTypes = {
  cardsFilters: PropTypes.shape({
    expiration: PropTypes.string,
    status: PropTypes.string,
    trailer: PropTypes.string,
  }).isRequired,
  onResetFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
};

export default LocationFilters;
